if (!customElements.get('product-template')) {
  class ProductTemplate extends HTMLElement {
    static observedAttributes = ['disabled'];

    constructor () {
      super();
      this.product = null;
      this.handle = this.dataset.productHandle ?? null;
      this.disabled = this?.disabled === 'true';
      this.isQuickView = this?.dataset?.isQuickView === 'true'
    }

    disconnectedCallback () {
      if (this.product) {
        this.product.onUnload();
      }
    }

    setRecentlyViewed () {
      let storage = localStorage.getItem('advanced-recently-viewed-product');
      let data = [];
      try {
        data = JSON.parse(storage);
        if (!data) {
          throw new Error('storage not found');
        }
        if (this.handle) {
          data = data.filter(value => value !== this.handle);
        }
      } catch (error) {
        data = [];
        console.warn('Error parsing JSON:', error);
      }
      if (this.handle) {
        data.unshift(this.handle);
      }
      data.splice(9);
      try {
        localStorage.setItem('advanced-recently-viewed-product', JSON.stringify(data));
      } catch (e) {
        console.warn('Error stringify JSON:', error);
      }
    }

    connectedCallback () {
      if (!this.disabled) {
        this.product = new window.theme.Product(this);
        if(!this.isQuickView)  {
          this.setRecentlyViewed();
        }
      }
    }

    attributeChangedCallback (name, oldValue, newValue) {
      if (name === 'disabled') {
        if (oldValue !== newValue) {
          if (newValue !== 'true') {
            this.disabled = false;
            this.connectedCallback();
          } else {
            this.disabled = true;
            this.disconnectedCallback();
          }
        }
      }
    }

  }

  customElements.define('product-template', ProductTemplate);
}